import Panel from './overridePanel/OverridePanel';
import Interface from './overrideInterface/OverrideInterface';
import MiwiInterface from './miwiInterface/MiwiInterface';
import OverrideInterface from './overrideInterface/OverrideInterface';
import Modal from './overrideModal/OverrideModal';
import OpenButton from './openOverride/OpenOverride';

export default {
    Panel,
    Interface,
    Modal,
    MiwiInterface,
    OverrideInterface,
    OpenButton,
} as any;

